export default "/static/dashboard/build/app/img/v2/6b6165e298f9efeabeb8c1d036a005d1.png";